var exports = {
  "tooltip": "xf61da738--2a4223--tooltip",
  "success": "xf61da738--2a4223--success",
  "error": "xf61da738--2a4223--error",
  "tooltip-visible": "xf61da738--2a4223--tooltip-visible",
  "tooltip-dissolve-in": "xf61da738--2a4223--tooltip-dissolve-in",
  "tooltip-hidden": "xf61da738--2a4223--tooltip-hidden",
  "tooltip-dissolve-out": "xf61da738--2a4223--tooltip-dissolve-out",
  "message": "xf61da738--2a4223--message",
  "favorites-link": "xf61da738--2a4223--favorites-link",
  "button": "xf61da738--2a4223--button",
};

module.exports = exports;
